import React, { Component } from 'react';
import TouchButton from '../../components/TouchButton';
import TouchLink from '../../components/TouchLink';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import { firebaseRoot } from '../../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import filepickerLibrary from 'filepicker-js';


const VideoUpload = React.createClass({

    mixins: [ReactFireMixin],

    componentWillMount() {
        this.lessonsRef = firebaseRoot.child("content/lessons/");
        this.bindAsArray(this.lessonsRef,'lessons');
    },

    render() {
        return (
            <div className="video-poster-upload">
                {this.state.lessons.map(lesson => {
                    return (
                        <div className="panel panel-default" key={lesson['.key']}>
                            <div className="panel-heading"> Lesson ID: {lesson['.key']} - {lesson.name}</div>
                            <div className="panel-body">
                                <div className="video-upload">
                                    <TouchButton className="pull-left">
                                        <div className="upload">
                                            <p>Upload video</p>
                                            <input className="input" onClick={this.handleOnClickAdd.bind(this, lesson['.key'], "video")}/>
                                        </div>
                                    </TouchButton>
                                    {
                                        lesson.videoId && <p className="panel-footer pull-right">Video Id: {lesson.videoId}</p>
                                    }
                                </div>
                                <div className="poster-upload">
                                    <TouchButton className="pull-left">
                                        <div className="upload">
                                            <p>Upload video poster</p>
                                            <input className="input" onClick={this.handleOnClickAdd.bind(this, lesson['.key'], "poster")}/>
                                        </div>
                                    </TouchButton>
                                    {
                                        lesson.videoId && <p className="panel-footer pull-right">Video Poster Id: {lesson.videoPosterId}</p>
                                    }
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    },

    handleOnClickAdd(lessonKey, type) {
        firebaseRoot.child('admin/settings/filestackKey').once('value').then(key => {
            filepicker.setKey(key.val());
            filepicker.pick(
                (link) => {
                    let stringArray = link.url.split('/');
                    let id = stringArray[stringArray.length - 1];
                    if (type === "video") {
                        firebaseRoot.child('content/lessons/').child(lessonKey).child("videoId").set(id);
                    } else {
                        firebaseRoot.child('content/lessons/').child(lessonKey).child("videoPosterId").set(id);
                    }
                }
            );
        }, window.alert);
    }

});

export default VideoUpload;



/** WEBPACK FOOTER **
 ** ./src/admin/screens/VideoUpload.js
 **/